// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminOrganization } from './AdminOrganization';
import {
  AdminOrganizationFromJSON,
  AdminOrganizationFromJSONTyped,
  AdminOrganizationToJSON,
  AdminOrganizationToJSONTyped,
} from './AdminOrganization';

/**
 *
 * @export
 * @interface ListAdminOrganizations200Response
 */
export interface ListAdminOrganizations200Response {
  /**
   *
   * @type {Array<AdminOrganization>}
   * @memberof ListAdminOrganizations200Response
   */
  data: Array<AdminOrganization>;
}

/**
 * Check if a given object implements the ListAdminOrganizations200Response interface.
 */
export function instanceOfListAdminOrganizations200Response(
  value: object,
): value is ListAdminOrganizations200Response {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function ListAdminOrganizations200ResponseFromJSON(
  json: any,
): ListAdminOrganizations200Response {
  return ListAdminOrganizations200ResponseFromJSONTyped(json, false);
}

export function ListAdminOrganizations200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ListAdminOrganizations200Response {
  if (json == null) {
    return json;
  }
  return {
    data: (json['data'] as Array<any>).map(AdminOrganizationFromJSON),
  };
}

export function ListAdminOrganizations200ResponseToJSON(
  json: any,
): ListAdminOrganizations200Response {
  return ListAdminOrganizations200ResponseToJSONTyped(json, false);
}

export function ListAdminOrganizations200ResponseToJSONTyped(
  value?: ListAdminOrganizations200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: (value['data'] as Array<any>).map(AdminOrganizationToJSON),
  };
}
